import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router';

import HeaderColumn from '../header-column/HeaderColumn';
import HeaderLabel from '../header-label/HeaderLabel';

import scss from './UserManagementHeader.module.scss';

const UserManagementHeader = () => {
  const { t } = useTranslation('header');

  return (
    <HeaderColumn>
      <div className={scss.wrapper}>
        <Routes>
          <Route path='/create' element={<HeaderLabel>{t('createSystemUser')}</HeaderLabel>} />
          <Route path='/edit/:id' element={<HeaderLabel>{t('editSystemUser')}</HeaderLabel>} />
        </Routes>
      </div>
    </HeaderColumn>
  );
};

export default UserManagementHeader;
